import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { IEquityTableProps } from './types';
import { ProjectedBalanceFieldTable } from '../../../../components/ProjectedBalanceFieldTable';
import { FIRST_COLUMN_WIDTH, liabilitiesAndEquityPrefix } from '../../../../utils/form';
import {
  EQUITY_TABLE_NAMES,
  LIABILITIES_AND_EQUITY_FORM_NAMES,
  useGetLiabilityAndEquityTableHeadings,
} from '../../utils/form';

export const EquityTable: FC<IEquityTableProps> = ({ disabled = false }) => {
  const period = useWatch({ name: GLOBAL_PERIOD_NAME });

  const { getValues } = useFormContext();
  const { isExamplePage} = useExamplePreview()
  const { equityVariants, equityTotalRowTitle } = useGetLiabilityAndEquityTableHeadings(isExamplePage);

  const tableName = concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE);

  const totalName = concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE_TOTAL);

  const totalValues = getValues(totalName);
  const fields = getValues([
    concatWithDot(tableName, EQUITY_TABLE_NAMES.OWNERS_EQUITY),
    concatWithDot(tableName, EQUITY_TABLE_NAMES.ADDITIONAL_PAID_IN_CAPITAL),
    concatWithDot(tableName, EQUITY_TABLE_NAMES.RESERVES),
    concatWithDot(tableName, EQUITY_TABLE_NAMES.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME),
    concatWithDot(tableName, EQUITY_TABLE_NAMES.RETAINED_EARNINGS),
  ]);

  return (
    <ProjectedBalanceFieldTable
      disabled={disabled}
      firstColumnWidth={FIRST_COLUMN_WIDTH}
      name={tableName}
      rows={fields}
      rowTitles={equityVariants}
      totalRowTitle={equityTotalRowTitle}
      totalName={totalName}
      period={period}
      totalValues={totalValues}
    />
  );
};
